import Vue from 'vue'

import { Redemption } from '~models/redemption'

export default Vue.extend({
  computed: {
    redemption(): Redemption {
      return this.$store.state.redemptions.redemption
    },
    cancellationUrl(): string {
      return this.$store.state.redemptions.redemption.cancellationUrl
    },
    loading(): boolean {
      return this.$store.state.redemptions.loading
    },
    errors(): string[] {
      return this.$store.state.redemptions.errors
    },
    redemptionUltimateFailureReason(): string {
      return this.$store.state.redemptions.ultimateFailureReason
    },
  },

  created() {
    if (!this.redemption.id) {
      this.$router.push({ name: 'home' })

      return
    }

    this.$store.dispatch('redemptions/setupKeepalive')
  },
})
